var countersInit;

(function ($) {

	const selectors = {
		counter: '[data-counter]',
	}

	countersInit = function () {

		$(selectors.counter).each((i, el) => {
			new Counter(el);
		});

	}

	class Counter {

		constructor(el) {

			this.$counter = $(el);

			if (this.$counter.length) {
				this.init();
				this.bind();
			}
		}

		init() {
			this.time = 2000;
			this.$counter.text('0');

		}
		bind() {
			// const self = this;
			this.count = this.count.bind(this);
			this.$counter.on('scrolled-into-view', (e) => { this.count(); });
		}

		count(el) {

			var counter_value = this.$counter.attr('data-count-to');
			var target_num = parseInt(counter_value);

			var interval = this.time / target_num;
			var current_num = 0;

			var is_large_number = interval < 5;

			var step = is_large_number ? 10 : 1;
			interval = is_large_number ? 10 * interval : interval;

			var timer = setInterval(() => {

				if (current_num >= target_num) {
					var formatted = (target_num >= 1000) ? target_num.toString().slice(0, -3) + '.' + target_num.toString().substr(target_num.toString().length - 3) : target_num;
					this.$counter.text(formatted);
					clearInterval(timer);
					return;
				}

				var formatted = (current_num >= 1000) ? current_num.toString().slice(0, -3) + '.' + current_num.toString().substr(current_num.toString().length - 3) : current_num;

				this.$counter.text(formatted);
				current_num += step;

			}, interval);

		}

	}

})(jQuery);


export default countersInit;